import { render } from "./BackClaim.vue?vue&type=template&id=bb3c204a&scoped=true"
import script from "./BackClaim.vue?vue&type=script&lang=js"
export * from "./BackClaim.vue?vue&type=script&lang=js"

import "./BackClaim.vue?vue&type=style&index=0&id=bb3c204a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3c204a"]])

export default __exports__